import clsx from 'clsx';
import React from 'react';

import type { TITVNetwork } from '../Network/interfaces';
import TITVMultistreamFeatureNetworkSection from './NetworkSection';

interface TITVMultistreamFeatureNetworkSectionsProps {
  inProgressStreamNetworkId?: number;
  titvNetworks?: TITVNetwork[];
}

const TITVMultistreamFeatureNetworkSections = ({
  inProgressStreamNetworkId,
  titvNetworks,
}: TITVMultistreamFeatureNetworkSectionsProps) => {
  if (!titvNetworks?.length) {
    return null;
  }

  const isInprogressNetwork =
    titvNetworks.some((titvNetwork) => titvNetwork.id === inProgressStreamNetworkId) || false;

  return (
    <article
      className={clsx(
        '-ml-16 w-[100svw] bg-grayscale-beige/50 px-16 sm:-ml-28 sm:px-28 xl:-ml-[calc(50svw_-_628px)] xl:px-0',
        isInprogressNetwork ? 'order-1' : 'order-3'
      )}
    >
      <div className="mx-auto flex w-full flex-col gap-y-80 py-48 lg:py-56 xl:max-w-[1256px]">
        {titvNetworks.map((titvNetwork) => (
          <TITVMultistreamFeatureNetworkSection
            key={titvNetwork.id}
            isInprogressNetwork={titvNetwork.id === inProgressStreamNetworkId}
            titvNetwork={titvNetwork}
          />
        ))}
      </div>
    </article>
  );
};

export default TITVMultistreamFeatureNetworkSections;
